const PrivacyPolicyStyles = {
    heading: {
        fontWeight: 600,
        fontSize: '24px',
        pt: 2,
        pb: 1
    }
}

export default PrivacyPolicyStyles